import { css } from 'styled-components'

const jsStyles = {
    alignment: (align) => css`
      ${align === 'center'
          ? `
            right: 50%;
            transform: translateX(50%);
          ` : ''}
      ${align === 'left' ? 'left: 0;' : ''}
      ${align === 'right' ? 'right: 0;' : ''}
    }`,
}

export default jsStyles
